import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import ScrollUpButton from "react-scroll-up-button";
import styled from 'styled-components';

import '../../css/pe-icon-7.css';
import ContactModal from '../../components/ContactModal';

const ModernFooter = styled.footer`
  background: linear-gradient(180deg, #0a0e27 0%, #050810 100%);
  border-top: 1px solid rgba(81, 194, 201, 0.2);
  padding: 60px 0 30px;
  
  .footer-list-title {
    color: #ffffff !important;
    font-weight: 600;
    margin-bottom: 1.5rem;
    font-size: 1.1rem;
  }
  
  .footer-list-menu {
    list-style: none;
    padding: 0;
    
    li {
      margin-bottom: 0.75rem;
      
      a, button {
        color: #94a3b8;
        text-decoration: none;
        transition: all 0.3s ease;
        display: inline-block;
        background: none;
        border: none;
        padding: 0;
        font-family: inherit;
        font-size: inherit;
        cursor: pointer;
        text-align: left;
        
        &:hover {
          color: #51c2c9;
          transform: translateX(5px);
        }
      }
    }
  }
  
  .copyright {
    color: #64748b;
    font-size: 0.9rem;
    margin-top: 2rem;
  }
  
  .footer-description {
    color: #94a3b8;
    line-height: 1.6;
    margin-bottom: 1.5rem;
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
  
  a {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    background: rgba(81, 194, 201, 0.1);
    border: 1px solid rgba(81, 194, 201, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #51c2c9;
    transition: all 0.3s ease;
    
    &:hover {
      background: rgba(81, 194, 201, 0.2);
      border-color: rgba(81, 194, 201, 0.4);
      transform: translateY(-3px);
    }
    
    i {
      font-size: 1.2rem;
    }
  }
`;

class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false
        };
        this.toggleModal = this.toggleModal.bind(this);
    }

    toggleModal() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }

    render() {
        return (
            <React.Fragment>
                <ContactModal show={this.state.modal} onHide={this.toggleModal} />
                <ModernFooter className="bg-footer">
                    <div className="container">
                        <Row>
                            <Col lg="4" md="6">
                                <div className="text-white">
                                    <h3 className="mb-3 footer-list-title">Khyros</h3>
                                    <p className="footer-description">
                                        Advanced geospatial intelligence powered by artificial intelligence. 
                                        Transforming data into actionable insights.
                                    </p>
                                    <SocialLinks>
                                        <a href="https://app.khyros.ai/" target="_blank" rel="noopener noreferrer" title="Platform">
                                            <i className="mdi mdi-web"></i>
                                        </a>
                                        <button onClick={this.toggleModal} title="Contact" style={{ background: 'none', border: 'none', padding: 0 }}>
                                            <i className="mdi mdi-email"></i>
                                        </button>
                                    </SocialLinks>
                                </div>
                            </Col>
                            <Col lg="2" md="6">
                                <div>
                                    <p className="text-white footer-list-title">Product</p>
                                    <ul className="list-unstyled footer-list-menu">
                                        <li><a href="/#features">Features</a></li>
                                        <li><a href="/#about">About</a></li>
                                        <li><a href="/#services">Applications</a></li>
                                    </ul>
                                </div>
                            </Col>
                            <Col lg="3" md="6">
                                <div>
                                    <p className="text-white footer-list-title">Resources</p>
                                    <ul className="list-unstyled footer-list-menu">
                                        <li><Link to="/privacy" target="_top">Privacy Policy</Link></li>
                                        <li><Link to="/eula" target="_top">End User License Agreement</Link></li>
                                        <li><Link to="/terms" target="_top">Terms of Service</Link></li>
                                    </ul>
                                </div>
                            </Col>
                            <Col lg="3" md="6">
                                <div>
                                    <p className="text-white footer-list-title">Company</p>
                                    <ul className="list-unstyled footer-list-menu">
                                        <li><button onClick={this.toggleModal}>Contact Us</button></li>
                                        <li><a href="https://app.khyros.ai/" target="_blank" rel="noopener noreferrer">Platform Login</a></li>
                                    </ul>
                                </div>
                            </Col>
                        </Row>
                        <Row className="mt-5">
                            <Col lg="12">
                                <div className="text-center">
                                    <p className="copyright">{new Date().getFullYear()} © Khyros. All rights reserved.</p>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </ModernFooter>
                <ScrollUpButton 
                    style={{ 
                        width: "40px",
                        height: "40px",
                        position: "fixed",
                        bottom: "30px", 
                        right: "30px", 
                        padding: "8px",
                        textAlign: "center", 
                        zIndex: "10000", 
                        borderRadius: "8px", 
                        background: "linear-gradient(135deg, #51c2c9 0%, #2eb8bf 100%)",
                        border: "none",
                        boxShadow: "0 4px 15px rgba(81, 194, 201, 0.4)"
                    }} 
                />
            </React.Fragment>
        );
    }
}

export default Footer;
